import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prettyFilePath',
  standalone: false,
})
@Injectable()
export class PrettyFilePath implements PipeTransform {
  // This is used for file meta file paths.
  public transform(value: string): string {
    const parts = value.split('/');
    return parts[parts.length - 1];
  }
}
